import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BodyErrorsDirective } from './body-errors.directive';
import { ErrorsComponent } from './errors.component';
import { HostErrorsDirective } from './host-errors.directive';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    OverlayModule,
    PortalModule
  ],
  declarations: [
    ErrorsComponent,
    HostErrorsDirective,
    BodyErrorsDirective
  ],
  exports: [
    ErrorsComponent,
    HostErrorsDirective,
    BodyErrorsDirective
  ]
})
export class ErrorsModule {
}
